type Itinerary = {
  carbonFootprint?: {
    isEco: boolean;
  };
};

const predicate =
  (hasCarbonFootprintApplied: boolean) =>
  (itinerary: Itinerary): boolean | undefined => {
    return (
      !hasCarbonFootprintApplied ||
      (itinerary.carbonFootprint && itinerary.carbonFootprint.isEco)
    );
  };

export default predicate;
